import { render, staticRenderFns } from "./BackBtn.vue?vue&type=template&id=d5b8ec7c&scoped=true"
import script from "./BackBtn.vue?vue&type=script&lang=js"
export * from "./BackBtn.vue?vue&type=script&lang=js"
import style0 from "./BackBtn.vue?vue&type=style&index=0&id=d5b8ec7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5b8ec7c",
  null
  
)

export default component.exports